// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8E2QV","labelBlock":"styles_labelBlock__55L76","avatar":"styles_avatar__OgmoZ","avatarName":"styles_avatarName__YpK+c","name":"styles_name__EJ8-U"};